
export const FETCH_NETFLIX_ORIGINALS = 'FETCH_NETFLIX_ORIGINALS'
export const FETCH_NETFLIX_ORIGINALS_REQUEST = 'FETCH_NETFLIX_ORIGINALS_REQUEST'
export const FETCH_NETFLIX_ORIGINALS_SUCCESS = 'FETCH_NETFLIX_ORIGINALS_SUCCESS'